// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.event-chip-width {\n  width: 170px !important;\n  justify-content: center;\n  color: black !important;\n}\n", ""]);
// Exports
module.exports = exports;
